export const publicationList = [
  {
    year: '2023/2',
    part: 1,
    cover: 'collection-JAS-23-2',
    filePath: 'collections/issues/full/JAS-2023-2.pdf',
    articles: [
      {
        id: '2023/2-1',
        author: 'Bianca R. KARDA',
        path: '1_bianca-karda_jas_2023-2'
      },
      {
        id: '2023/2-2',
        author: 'Adrian MATIOC',
        path: '2_adrian-matioc_jas_2023-2'
      },
      {
        id: '2023/2-3',
        author: 'Sorin-Dan BOLDEA & Iustin FILIP',
        path: '3_sorin-dan-boldea_iustin-filip_jas_2023-2'
      },
      {
        id: '2023/2-4',
        author: 'Ciprian SCURTEA',
        path: '4_ciprian-scurtea_jas_2023-2'
      },
      {
        id: '2023/2-5',
        author: 'Ștefan TUNSOIU',
        path: '5_stefan-tunsoiu_jas_2023-2'
      }
    ]
  },
  {
    year: '2023/1',
    part: 1,
    cover: 'collection-JAS-23-1',
    filePath: 'collections/issues/full/JAS-2023-1.pdf',
    articles: [
      {
        id: '2023/1-1',
        author: 'Sorana MAIER',
        path: '1_sorana-maier_jas_2023-1'
      },
      {
        id: '2023/1-2',
        author: 'Ondina TĂUT',
        path: '2_ondina-taut_jas_2023-1'
      },
      {
        id: '2023/1-3',
        author: 'Nadia-Diana ARSIN',
        path: '3_nadia-diana-arsin_jas_2023-1'
      },
      {
        id: '2023/1-4',
        author: 'Andreea DARIE',
        path: '4_andreea-darie_jas_2023-1'
      },
      {
        id: '2023/1-5',
        author: 'Adrian NEACȘU',
        path: '5_adrian-neacsu_jas_2023-1'
      },
      {
        id: '2023/1-6',
        author: 'Ozana BARABANCEA',
        path: '6_ozana-barabancea_jas_2023-1'
      },
      {
        id: '2023/1-7',
        author: 'Alin GAVRILĂ',
        path: '7_alin-gavrila_jas_2023-1'
      }
    ]
  },
  {
    year: '2022/2',
    part: 2,
    cover: 'collection-JAS-22-2',
    filePath: 'collections/issues/full/JAS-2022-2.pdf',
    articles: [
      {
        id: '2022/2-1',
        author: 'Dragoș BUHAGIAR',
        path: '1_dragos-buhagiar_jas_2022-2'
      },
      {
        id: '2022/2-2',
        author: 'ALEXANDRU GRECU',
        path: '2_alexandru-grecu_jas_2022-2'
      },
      {
        id: '2022/2-3',
        author: 'ALICE GOLISANO',
        path: '3_alice-golisano_jas_2022-2'
      },
      {
        id: '2022/2-4',
        author: 'ANDRADA CAZAN',
        path: '4_andrada-cazan_jas_2022-2'
      },
      {
        id: '2022/2-5',
        author: 'ADRIANA IOANA ISPAS',
        path: '5_adriana-ioana-ispas_jas_2022-2'
      },
      {
        id: '2022/2-6',
        author: 'IUSTINIAN TURCU',
        path: '6_iustinian-turcu_jas_2022-2'
      },
      {
        id: '2022/2-7',
        author: 'SIMONA POP',
        path: '7_simona-pop_jas_2022-2'
      }
    ]
  },
  {
    year: '2022/1',
    part: 1,
    cover: 'collection-JAS-22-1',
    filePath: 'collections/issues/full/JAS-2022-1.pdf',
    articles: [
      {
        id: '2022/1-1',
        author: 'Diana FUFEZAN',
        path: '1_diana-fufezan_jas_2022-1'
      },
      {
        id: '2022/1-2',
        author: 'Rareș Florin STOICA',
        path: '2_rares-florin-stoica_jas_2022-1'
      },
      {
        id: '2022/1-3',
        author: 'Codruța PRESECAN',
        path: '3_codruta-presecan_jas_2022-1'
      },
      {
        id: '2022/1-4',
        author: 'Simona CHIȚAN',
        path: '4_simona-chitan_jas_2022-1'
      },
      {
        id: '2022/1-5',
        author: 'Vlad ROBAȘ',
        path: '5_vlad-robas_jas_2022-1'
      },
      {
        id: '2022/1-6',
        author: 'Ianoș PETRAȘCU',
        path: '6_ianos-petrascu_jas_2022-1'
      },
      {
        id: '2022/1-7',
        author: 'Anca ARNĂU',
        path: '7_anca-arnau_jas_2022-1'
      }
    ]
  },
  {
    year: '2021/2',
    part: 2,
    cover: 'collection-JAS-21-2',
    filePath: 'collections/issues/full/JAS-2021-2.pdf',
    articles: [
      {
        id: '2021/2-1',
        author: 'Ion M. Tomuș',
        path: '1_ion-m-tomus_jas_2021-2'
      },
      {
        id: '2021/2-2',
        author: 'Diana Nechit',
        path: '2_diana-nechit_jas_2021-2'
      },
      {
        id: '2021/2-3',
        author: 'Andrei C. Șerban',
        path: '3_andrei-c-serban_jas_2021-2'
      },
      {
        id: '2021/2-4',
        author: 'Alba Stanciu',
        path: '4_alba-stanciu_jas_2021-2'
      },
      {
        id: '2021/2-5',
        author: 'Melinda Samson',
        path: '5_melinda-samson_jas_2021-2'
      },
      {
        id: '2021/2-6',
        author: 'Adrian Strâmtu',
        path: '6_adrian-stramtu_jas_2021-2'
      },
      {
        id: '2021/2-7',
        author: 'Ionica Alexiu',
        path: '7_ionica-alexiu_jas_2021-2'
      }
    ]
  },
  {
    year: '2021/1',
    part: 1,
    cover: 'collection-JAS-21-1',
    filePath: 'collections/issues/full/JAS-2021-1.pdf',
    articles: [
      {
        id: '2021/1-1',
        author: 'Alexa Visarion',
        path: '1_alexa-visarion_jas_2021-1'
      },
      {
        id: '2021/1-2',
        author: 'Eugen Jebeleanu',
        path: '2_eugen-jebeleanu_jas_2021-1'
      },
      {
        id: '2021/1-3',
        author: 'Silvia Macrea',
        path: '3_silvia-macrea_jas_2021-1'
      },
      {
        id: '2021/1-4',
        author: 'Adrian Matioc',
        path: '4_adrian-matioc_jas_2021-1'
      },
      {
        id: '2021/1-5',
        author: 'Ana-Blanca Ciocoi-Pop',
        path: '5_ana-blanca-ciocoi-pop_jas_2021-1'
      },
      {
        id: '2021/1-6',
        author: 'Miruna Ciocoi-Pop',
        path: '6_miruna-ciocoi-pop_jas_2021-1'
      },
      {
        id: '2021/1-7',
        author: 'Pali Vecsei',
        path: '7_pali-vecsei_jas_2021-1'
      },
      {
        id: '2021/1-8',
        author: 'Irina Ionescu',
        path: '8_irina-ionescu_jas_2021-1'
      },
      {
        id: '2021/1-9',
        author: 'Dan Bartha-Lazăr',
        path: '9_dan-bartha-lazar_jas_2021-1'
      },
      {
        id: '2021/1-10',
        author: 'Silviu Scrob',
        path: '10_silviu-scrob_jas_2021-1'
      },
      {
        id: '2021/1-11',
        author: 'Eleni-Alexandra Popa',
        path: '11_eleni-alexandra-popa_jas_2021-1'
      }
    ]
  },
  {
    year: '2020/2',
    part: 2,
    cover: 'collection-JAS-20-2',
    filePath: 'collections/issues/full/JAS-2020-2.pdf',
    articles: [
      {
        id: '2020/2-1',
        author: 'Conferință / Conference transcript',
        path: '1_conf_jas_2020-2'
      },
      {
        id: '2020/2-2',
        author: 'Conferință / Conference transcript',
        path: '2_conf_jas_2020-2'
      },
      {
        id: '2020/2-3',
        author: 'Conferință / Conference transcript',
        path: '3_conf_jas_2020-2'
      },
      {
        id: '2020/2-4',
        author: 'Diana Nechit',
        path: '4_diana-nechit_jas_2020-2'
      },
      {
        id: '2020/2-5',
        author: 'Cristina Blaga',
        path: '5_cristina-blaga_jas_2020-2'
      },
      {
        id: '2020/2-6',
        author: 'Andrei C. Șerban',
        path: '6_andrei-c-serban_jas_2020-2'
      },
      {
        id: '2020/2-7',
        author: 'Oana Marin',
        path: '7_oana-marin_jas_2020-2'
      },
      {
        id: '2020/2-8',
        author: 'Anca Boieru',
        path: '8_anca-boieru_jas_2020-2'
      }
    ]
  },
  {
    year: '2020/1',
    part: 1,
    cover: 'collection-JAS-20-1',
    filePath: 'collections/issues/full/JAS-2020-1.pdf',
    articles: [
      {
        id: '2020/1-1',
        author: 'George Banu',
        path: '1_george-banu_jas_2020-1'
      },
      {
        id: '2020/1-2',
        author: 'George Banu',
        path: '2_george-banu_jas_2020-1'
      },
      {
        id: '2020/1-3',
        author: 'George Banu',
        path: '3_george-banu_jas_2020-1'
      },
      {
        id: '2020/1-4',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '4_conf_jas_2020-1'
      },
      {
        id: '2020/1-5',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '5_conf_jas_2020-1'
      },
      {
        id: '2020/1-6',
        author: 'Ofelia Popii',
        path: '6_ofelia-popii_jas_2020-1'
      },
      {
        id: '2020/1-7',
        author: 'Sorana Maier',
        path: '7_sorana-maier_jas_2020-1'
      }
    ]
  },
  {
    year: '2019/2',
    part: 2,
    cover: 'collection-JAS-19-2',
    filePath: 'collections/issues/full/JAS-2019-2.pdf',
    articles: [
      {
        id: '2019/2-1',
        author: 'Tobias Biancone',
        path: '1_tobias-biancone_jas_2019-2'
      },
      {
        id: '2019/2-2',
        author: 'George Banu',
        path: '2_george-banu_jas_2019-2'
      },
      {
        id: '2019/2-3',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '3_conf_jas_2019-2'
      },
      {
        id: '2019/2-4',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '4_conf_jas_2019-2'
      },
      {
        id: '2019/2-5',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '5_conf_jas_2019-2'
      },
      {
        id: '2019/2-6',
        author: 'Mariko Anazawa',
        path: '6_mariko-anazawa_jas_2019-2'
      },
      {
        id: '2019/2-7',
        author: 'Constantin Necula',
        path: '7_constantin-necula_jas_2019-2'
      },
      {
        id: '2019/2-8',
        author: 'Ofelia Popii',
        path: '8_ofelia-popii_jas_2019-2'
      },
      {
        id: '2019/2-9',
        author: 'Alba Stanciu',
        path: '9_alba-stanciu_jas_2019-2'
      },
      {
        id: '2019/2-10',
        author: 'Alexandru Condurache',
        path: '10_alexandru-condurache_jas_2019-2'
      }
    ]
  },
  {
    year: '2019/1',
    part: 1,
    cover: 'collection-JAS-19-1',
    filePath: 'collections/issues/full/JAS-2019-1.pdf',
    articles: [
      {
        id: '2019/1-1',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '1_conf_jas_2019-1'
      },
      {
        id: '2019/1-2',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '2_conf_jas_2019-1'
      },
      {
        id: '2019/1-3',
        author: 'CONFERINȚĂ / CONFERENCE TRANSCRIPT',
        path: '3_conf_jas_2019-1'
      },
      {
        id: '2019/1-4',
        author: 'Andrei C. Șerban',
        path: '4_andrei-c-serban_jas_2019-1'
      },
      {
        id: '2019/1-5',
        author: 'Ion M. Tomuș',
        path: '5_ion-m-tomus_jas_2019-1'
      },
      {
        id: '2019/1-6',
        author: 'Diana Fufezan',
        path: '6_diana-fufezan_jas_2019-1'
      },
      {
        id: '2019/1-7',
        author: 'Eugen Gyemant',
        path: '7_eugen-gyemant_jas_2019-1'
      },
      {
        id: '2019/1-8',
        author: 'Diana Nechit',
        path: '8_diana-nechit_jas_2019-1'
      },
      {
        id: '2019/1-9',
        author: 'Oana Marin',
        path: '9_oana-marin_jas_2019-1'
      },
      {
        id: '2019/1-10',
        author: 'Anca Berlogea',
        path: '10_anca-berlogea_jas_2019-1'
      },
      {
        id: '2019/1-11',
        author: 'Cristina Blaga',
        path: '11_cristina-blaga_jas_2019-1'
      }
    ]
  },
  {
    year: '2015/2',
    part: 2,
    cover: 'collection-JAS-15-2',
    filePath: 'collections/issues/full/JAS-2015-2.pdf',
    articles: [
      {
        id: '2015/2-1',
        author: 'Klaus Maria Brandauer, George Banu, Irina Margareta Nistor',
        path: '1_klaus-maria-brandauer_george-banu_irina-margareta-nistor_jas_2015-2'
      },
      {
        id: '2015/2-2',
        author: 'George Banu, Emmanuel Demarcy-Mota',
        path: '2_george-banu_emmanuel-demarcy-mota_jas_2015-2'
      },
      {
        id: '2015/2-3',
        author:
          'George Banu, Tauras Cizas, Remigijus Vilkaitis, Roman Doljanski',
        path: '3_george-banu_tauras-cizas_remigijus-vilkaitis_roman-doljanski_jas_2015-2'
      },
      {
        id: '2015/2-4',
        author: 'Octavian Saiu, Jin Xing',
        path: '4_octavian-saiu_jin-xing_jas_2015-2'
      },
      {
        id: '2015/2-5',
        author: 'Alexa Visarion, Ilie Gheorghe, Constantin Chiriac',
        path: '5_alexa-visarion_ilie-gheorghe_constantin-chiriac_jas_2015-2'
      },
      {
        id: '2015/2-6',
        author: 'Anca Bradu',
        path: '6_anca-bradu_jas_2015-2'
      },
      {
        id: '2015/2-7',
        author: 'Diana NECHIT',
        path: '7_diana-nechit_jas_2015-2'
      },
      {
        id: '2015/2-8',
        author: 'Andrei C. ȘERBAN',
        path: '8_andrei-c-serban_jas_2015-2'
      }
    ]
  },
  {
    year: '2015/1',
    part: 1,
    cover: 'collection-JAS-15-1',
    filePath: 'collections/issues/full/JAS-2015-1.pdf',
    articles: [
      {
        id: '2015/1-1',
        author: 'George Banu, Pippo Delbono',
        path: '1_george-banu_pippo-delbono_jas_2015-1'
      },
      {
        id: '2015/1-2',
        author: 'Kalina Stefanova',
        path: '2_kalina-stefanova_jas_2015-1'
      },
      {
        id: '2015/1-3',
        author: 'Constantin Chiriac',
        path: '3_constantin-chiriac_jas_2015-1'
      },
      {
        id: '2015/1-4',
        author: 'Anca Bradu',
        path: '4_anca-bradu_jas_2015-1'
      },
      {
        id: '2015/1-5',
        author: 'Alba Stanciu',
        path: '5_alba-stanciu_jas_2015-1'
      },
      {
        id: '2015/1-6',
        author: 'Diana Nechit',
        path: '6_diana-nechit_jas_2015-1'
      },
      {
        id: '2015/1-7',
        author: 'Ioana Petcu',
        path: '7_ioana-petcu_jas_2015-1'
      },
      {
        id: '2015/1-8',
        author: 'Ana Mujat',
        path: '8_ana-mujat_jas_2015-1'
      }
    ]
  },
  {
    year: '2014/2',
    part: 2,
    cover: 'collection-JAS-14-2',
    filePath: 'collections/issues/full/JAS-2014-2.pdf',
    articles: [
      {
        id: '2014/2-1',
        author: 'Jan Lauwers',
        path: '1_jan-lauwers_jas_2014-2'
      },
      {
        id: '2014/2-2',
        author: 'Ivan Vîrîpaev',
        path: '2_ivan-viripaev_jas_2014-2'
      },
      {
        id: '2014/2-3',
        author: 'Esteve Soler',
        path: '3_esteve-soler_jas_2014-2'
      },
      {
        id: '2014/2-4',
        author: 'Ilinca Tamara Todoruț',
        path: '4_ilinca-tamara-todorut_jas_2014-2'
      },
      {
        id: '2014/2-5',
        author: 'Diana Nechit',
        path: '5_diana-nechit_jas_2014-2'
      },
      {
        id: '2014/2-6',
        author: 'Alexandra Pâzgu',
        path: '6_alexandra-pazgu_jas_2014-2'
      },
      {
        id: '2014/2-7',
        author: 'Bogdan Georgescu',
        path: '7_bogdan-georgescu_jas_2014-2'
      },
      {
        id: '2014/2-8',
        author: 'Marcella Trifu',
        path: '8_marcella-trifu_jas_2014-2'
      },
      {
        id: '2014/2-9',
        author: 'Raluca Blaga',
        path: '9_raluca-blaga_jas_2014-2'
      },
      {
        id: '2014/2-10',
        author: 'Mirona Tatu',
        path: '10_mirona-tatu_jas_2014-2'
      }
    ]
  },
  {
    year: '2014/1',
    part: 1,
    cover: 'collection-JAS-14-1',
    filePath: 'collections/issues/full/JAS-2014-1.pdf',
    articles: [
      {
        id: '2014/1-1',
        author: 'George Banu',
        path: '1_george-banu_jas_2014-1'
      },
      {
        id: '2014/1-2',
        author: 'Peter Stein',
        path: '2_peter-stein_jas_2014-1'
      },
      {
        id: '2014/1-3',
        author: 'Gigi Căciuleanu',
        path: '3_gigi-caciuleanu_jas_2014-1'
      },
      {
        id: '2014/1-4',
        author: 'Dan Hăulică',
        path: '4_dan-haulica_jas_2014-1'
      },
      {
        id: '2014/1-5',
        author: 'Constantin Chiriac',
        path: '5_constantin-chiriac_jas_2014-1'
      },
      {
        id: '2014/1-6',
        author: 'Alba Simina Stanciu',
        path: '6_alba-simina-stanciu_jas_2014-1'
      },
      {
        id: '2014/1-7',
        author: 'Claudia Domnicar',
        path: '7_claudia-domnicar_jas_2014-1'
      },
      {
        id: '2014/1-8',
        author: 'Ioan Ardelean',
        path: '8_ioan-ardelean_jas_2014-1'
      },
      {
        id: '2014/1-9',
        author: 'Adriana Boantă',
        path: '9_adriana-boanta_jas_2014-1'
      },
      {
        id: '2014/1-10',
        author: 'Nicoleta Hâncu',
        path: '10_nicoleta-hancu_jas_2014-1'
      },
      {
        id: '2014/1-11',
        author: 'Doriana Tăut',
        path: '11_doriana-taut_jas_2014-1'
      }
    ]
  },
  {
    year: '2011/1',
    part: 1,
    cover: 'collection-JAS-11-1',
    filePath: 'collections/issues/full/JAS-2011-1.pdf',
    articles: [
      {
        id: '2011/1-1',
        author: 'Oriza Hirata',
        path: '1_oriza-hirata_jas_2011_1'
      },
      {
        id: '2011/1-2',
        author: 'Alexandra Pâzgu',
        path: '2_alexandra-pazgu_jas_2011_1'
      },
      {
        id: '2011/1-3',
        author: 'Dan C. Mihăilescu',
        path: '3_dan-c-mihailescu_jas_2011_1'
      },
      {
        id: '2011/1-4',
        author: 'Constantin Chiriac',
        path: '4_constantin-chiriac_jas_2011_1'
      },
      {
        id: '2011/1-5',
        author: 'Ion M. Tomuş',
        path: '5_ion-m-tomus_jas_2011_1'
      },
      {
        id: '2011/1-6',
        author: 'Anca Bradu',
        path: '6_anca-bradu_jas_2011_1'
      },
      {
        id: '2011/1-7',
        author: 'Radu-Alexandru Nica',
        path: '7_radu-alexandru-nica_jas_2011_1'
      },
      {
        id: '2011/1-8',
        author: 'Alina Mazilu',
        path: '8_alina-mazilu_jas_2011_1'
      },
      {
        id: '2011/1-9',
        author: 'Dan Glasu',
        path: '9_dan-glasu_jas_2011_1'
      },
      {
        id: '2011/1-10',
        author: 'Doriana Tăut',
        path: '10_doriana-taut_jas_2011_1'
      }
    ]
  },
  {
    year: '2010/2',
    part: 2,
    cover: 'collection-JAS-10-2',
    filePath: 'collections/issues/full/JAS-2010-2.pdf',
    articles: [
      {
        id: '2010/2-1',
        author: 'Eugenio Barba',
        path: '1_eugenio-barba_jas_2010_2'
      },
      {
        id: '2010/2-2',
        author: 'Nic Ularu',
        path: '2_nic-ularu_jas_2010_2'
      },
      {
        id: '2010/2-3',
        author: 'Daniela Magiaru',
        path: '3_daniela-magiaru_jas_2010_2'
      },
      {
        id: '2010/2-4',
        author: 'Stanca Scholz-Cionca',
        path: '4_stanca-scholz-cionca_jas_2010_2'
      },
      {
        id: '2010/2-5',
        author: 'Constantin Chiriac',
        path: '5_constantin-chiriac_jas_2010_2'
      },
      {
        id: '2010/2-6',
        author: 'Sorin Crişan',
        path: '6_sorin-crisan_jas_2010_2'
      },
      {
        id: '2010/2-7',
        author: 'Ion M. Tomuş',
        path: '7_ion-m-tomus_jas_2010_2'
      },
      {
        id: '2010/2-8',
        author: 'Alexandra Pâzgu',
        path: '8_alexandra-pazgu_jas_2010_2'
      },
      {
        id: '2010/2-9',
        author: 'Claudia Maior',
        path: '9_claudia-maior_jas_2010_2'
      },
      {
        id: '2010/2-10',
        author: 'Florin Coşuleţ',
        path: '10_florin-cosulet_jas_2010_2'
      },
      {
        id: '2010/2-11',
        author: 'Dan Glasu',
        path: '11_dan-glasu_jas_2010_2'
      },
      {
        id: '2010/2-12',
        author: 'Mircea Tomuş',
        path: '12_mircea-tomus_jas_2010_2'
      }
    ]
  },
  {
    year: '2010/1',
    part: 1,
    cover: 'collection-JAS-10-1',
    filePath: 'collections/issues/full/JAS-2010-1.pdf',
    articles: [
      {
        id: '2010/1-1',
        author: 'Mirella Patureau',
        path: '1_mirella-patureau_jas_2010-1'
      },
      {
        id: '2010/1-2',
        author: 'Daniela Magiaru',
        path: '2_daniela-magiaru_jas_2010-1'
      },
      {
        id: '2010/1-3',
        author: 'Ion M. Tomuş',
        path: '3_ion-m-tomus_jas_2010-1'
      },
      {
        id: '2010/1-4',
        author: 'Giorgio Strehler',
        path: '4_giorgio-strehler_jas_2010-1'
      },
      {
        id: '2010/1-5',
        author: 'Alexandra Pâzgu',
        path: '5_alexandra-pazgu_jas_2010-1'
      },
      {
        id: '2010/1-6',
        author: 'Claudia Maior',
        path: '6_claudia-maior_jas_2010-1'
      },
      {
        id: '2010/1-7',
        author: 'Hans-Dietrich Schmidt',
        path: '7_hans-dietrich-schmidt_jas_2010-1'
      },
      {
        id: '2010/1-8',
        author: 'Constantin Chiriac',
        path: '8_constantin-chiriac_jas_2010-1'
      },
      {
        id: '2010/1-9',
        author: 'Dan Glasu',
        path: '9_dan-glasu_jas_2010-1'
      },
      {
        id: '2010/1-10',
        author: 'Alina Mazilu',
        path: '10_alina-mazilu_jas_2010-1'
      },
      {
        id: '2010/1-11',
        author: 'Christian Jürgen Koch',
        path: '11_christian-jurgen-koch_jas_2010-1'
      }
    ]
  },
  {
    year: '2009/1',
    part: 1,
    cover: 'collection-JAS-09-1',
    filePath: 'collections/issues/full/JAS-2009-1.pdf',
    articles: [
      {
        id: '2009/1-1',
        author: 'George Banu',
        path: '1_george-banu_jas_2009-1'
      },
      {
        id: '2009/1-2',
        author: 'Constantin Chiriac',
        path: '2_constantin-chiriac_jas_2009-1'
      },
      {
        id: '2009/1-3',
        author: 'Mircea Tomuş',
        path: '3_mircea-tomus_jas_2009-1'
      },
      {
        id: '2009/1-4',
        author: 'Cornel Ungureanu',
        path: '4_cornel-ungureanu_jas_2009-1'
      },
      {
        id: '2009/1-5',
        author: 'Sorin Crişan',
        path: '5_sorin-crisan_jas_2009-1'
      },
      {
        id: '2009/1-6',
        author: 'Daniela Magiaru',
        path: '6_daniela-magiaru_jas_2009-1'
      },
      {
        id: '2009/1-7',
        author: 'Dan Glasu',
        path: '7_dan-glasu_jas_2009-1'
      },
      {
        id: '2009/1-8',
        author: 'Alina Mazilu',
        path: '8_alina-mazilu_jas_2009-1'
      },
      {
        id: '2009/1-9',
        author: 'Ion M. Tomuş',
        path: '9_ion-m-tomus_jas_2009-1'
      },
      {
        id: '2009/1-10',
        author: 'Radu-Alexandru Nica',
        path: '10_radu-alexandru-nica_jas_2009-1'
      },
      {
        id: '2009/1-11',
        author: 'Mirona-Ioana Tatu',
        path: '11_mirona-ioana-tatu_jas_2009-1'
      }
    ]
  }
]
